import {useTranslation} from 'react-i18next'
import {RowItem} from './RowItem'
import {useMemo} from 'react'
import {useAppSelector} from 'src/redux/hooks'
import {appSelector} from 'src/redux/slices/appSlices'

interface Props {
  showBeforeAfter: boolean
}

export const RowItemCity = ({showBeforeAfter}: Props) => {
  const {t} = useTranslation()
  const {orderSubDetail: after, beforeAmandement} = useAppSelector(appSelector)

  const before = useMemo(
    () => (!beforeAmandement ? after : beforeAmandement),
    [after, beforeAmandement]
  )

  return (
    <RowItem
      showBeforeAfter={showBeforeAfter}
      label={t('sub-order-kota')}
      before={before?.city?.city_name}
      after={after?.city?.city_name}
    />
  )
}
